<template>
    <section class="driver-section">
        <header class="driver-section__header">
            <p class="driver-section__title">
                {{ $t("driverProfile.vehicleLicense") }}
            </p>
        </header>

        <div class="driver-section__card">
            <div class="driver-section__grid driver-section__grid--double">
                <div class="driver-section__field">
                    <label class="driver-section__label required">
                        {{ $t("driverProfile.platNumber") }}
                    </label>
                    <input
                        v-model.trim="model.plat_number"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('plat_number') }"
                        :placeholder="$t('driverProfile.platNumber')"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('plat_number')"
                    >
                        {{ errors.first('plat_number') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label required">
                        {{ $t("driverProfile.vehicleType") }}
                    </label>
                    <a-select
                        v-model.number="model.vehicle_type_id"
                        class="tw-w-full"
                        :options="vehicleTypeList"
                        :placeholder="$t('driverProfile.vehicleType')"
                    ></a-select>
                    <div
                        class="driver-section__error"
                        v-if="errors.has('vehicle_type_id')"
                    >
                        {{ errors.first('vehicle_type_id') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.driverLicenseNo") }}
                    </label>
                    <input
                        v-model.trim="model.driver_license_no"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('driver_license_no') }"
                        :placeholder="$t('driverProfile.driverLicenseNo')"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('driver_license_no')"
                    >
                        {{ errors.first('driver_license_no') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.vehicleColor") }}
                    </label>
                    <input
                        v-model.trim="model.vehicle_color"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('vehicle_color') }"
                        :placeholder="$t('driverProfile.vehicleColor')"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('vehicle_color')"
                    >
                        {{ errors.first('vehicle_color') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.driverIssueDate") }}
                    </label>
                    <a-date-picker
                        v-model="model.driver_license_issue_date"
                        class="tw-w-full"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        :placeholder="$t('driverProfile.driverIssueDate')"
                    ></a-date-picker>
                    <div
                        class="driver-section__error"
                        v-if="errors.has('driver_license_issue_date')"
                    >
                        {{ errors.first('driver_license_issue_date') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.driverExpiredDate") }}
                    </label>
                    <a-date-picker
                        v-model="model.driver_license_expiry_date"
                        class="tw-w-full"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        :placeholder="$t('driverProfile.driverExpiredDate')"
                    ></a-date-picker>
                    <div
                        class="driver-section__error"
                        v-if="errors.has('driver_license_expiry_date')"
                    >
                        {{ errors.first('driver_license_expiry_date') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.guarantor1") }}
                    </label>
                    <input
                        v-model.trim="model.guarantor1"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('guarantor1') }"
                        :placeholder="$t('driverProfile.guarantor1')"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('guarantor1')"
                    >
                        {{ errors.first('guarantor1') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.guarantorPhone1") }}
                    </label>
                    <input
                        v-model="model.guarantor1_phone"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('guarantor1_phone') }"
                        :placeholder="$t('driverProfile.guarantorPhone1')"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('guarantor1_phone')"
                    >
                        {{ errors.first('guarantor1_phone') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.guarantor2") }}
                    </label>
                    <input
                        v-model.trim="model.guarantor2"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('guarantor2') }"
                        :placeholder="$t('driverProfile.guarantor2')"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('guarantor2')"
                    >
                        {{ errors.first('guarantor2') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.guarantorPhone2") }}
                    </label>
                    <input
                        v-model="model.guarantor2_phone"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('guarantor2_phone') }"
                        :placeholder="$t('driverProfile.guarantorPhone2')"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('guarantor2_phone')"
                    >
                        {{ errors.first('guarantor2_phone') }}
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from 'vuex';

export default {
    name: "vehicleLicense",
    props: ["value", "validate"],
    data() {
        return {
            errors: new Errors(),
            model: {}
        };
    },
    created() {
        this.model = this.value;
    },
    computed: {
        ...mapState("driver/driverProfile", ['formModels']),
        vehicleTypeList() {
            if (!this.formModels.vehicleType) return [];

            return this.formModels.vehicleType.map(el => ({
                value: el.vehicle_type_id,
                label: el.vehicle_types
            }));
        }
    },
    watch: {
        validate: function(error) {
            this.errors = new Errors(error.errors);
        }
    }
};
</script>

<style scoped>
.driver-section__header {
    margin-bottom: 10px;
}

.driver-section__title {
    margin: 0;
    color: #8ea0b4;
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    text-decoration: underline;
    text-underline-offset: 3px;
}

.driver-section__card {
    border: 1px solid #dfe6ee;
    border-radius: 10px;
    background: #fff;
    padding: 12px;
}

.driver-section__grid {
    display: grid;
    gap: 10px 16px;
}

.driver-section__grid--double {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.driver-section__field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.driver-section__label {
    margin: 0;
    color: #3f4d5d;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
}

.driver-section__error {
    color: #dc2626;
    font-size: 12px;
}

@media (max-width: 767px) {
    .driver-section__card {
        padding: 12px;
    }

    .driver-section__grid--double {
        grid-template-columns: 1fr;
    }
}
</style>
